import { UserAchCompanyLimitModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class CompanyUserAchCompanyLimit extends DomainEntity<UserAchCompanyLimitModelDto> {
    public get companyName() {
        return this.dto.achCompany?.companyName;
    }

    public get companyId() {
        return this.dto.achCompany?.companyId;
    }

    public get companyTotalDailyLimit() {
        return this.dto.achCompany?.totalDailyLimit;
    }

    public get secCodesFormatted() {
        const codes = this.dto.achCompany?.secCodes;
        return codes?.length ? codes.map(c => c.code).join(', ') : undefined;
    }

    public get entryDescription() {
        return this.dto.achCompany?.entryDescription;
    }

    public get pendingPerTransactionLimit() {
        return this.dto.pendingUserAchCompanyLimit?.perTransactionLimit;
    }

    public set pendingPerTransactionLimit(value: number | undefined) {
        if (!this.dto.pendingUserAchCompanyLimit) {
            this.dto.pendingUserAchCompanyLimit = {};
        }
        this.dto.pendingUserAchCompanyLimit.perTransactionLimit = value;
    }

    public get pendingDailyLimit() {
        return this.dto.pendingUserAchCompanyLimit?.dailyLimit;
    }

    public set pendingDailyLimit(value: number | undefined) {
        if (!this.dto.pendingUserAchCompanyLimit) {
            this.dto.pendingUserAchCompanyLimit = {};
        }
        this.dto.pendingUserAchCompanyLimit.dailyLimit = value;
    }

    public createDefault(): this {
        return new CompanyUserAchCompanyLimit({
            achCompany: {
                id: 0,
                companyName: '',
                companyId: '',
                totalDailyLimit: 0,
                notOnUsTransactionTypes: '',
                batchBalanceRequirements: '',
                onUsTransactionsRequired: 0,
                onUsAmountRequiredPerBatch: 0,
                isActive: false,
            },
        }) as this;
    }
}
